import React, { useEffect, useState } from 'react'
import { NinetailedPreviewPluginData } from '@lib/api/ninetailed'
import { useCommonServices } from '@lib/hooks'
import { NinetailedProvider } from '@ninetailed/experience.js-next'
import { NinetailedPlugin } from '@ninetailed/experience.js-plugin-analytics'
import { ninetailedConfig } from './config'
import { NinetailedEnabledContext } from './shared'

export interface NinetailedPersonalizationPreviewProviderProps {
  ninetailedPreviewPluginData: NinetailedPreviewPluginData
  children: React.ReactNode
}

export const NinetailedPersonalizationPreviewProvider: React.FC<NinetailedPersonalizationPreviewProviderProps> = ({
  children,
  ninetailedPreviewPluginData,
}) => {
  const [plugins, setPlugins] = useState<NinetailedPlugin[]>([])
  const { ninetailedPersonalizationService } = useCommonServices()
  ninetailedPersonalizationService.setPreviewMode(true)

  useEffect(() => {
    ninetailedPersonalizationService.getPluginsForPreview(ninetailedPreviewPluginData).then(setPlugins)
  }, [ninetailedPersonalizationService, ninetailedPreviewPluginData])

  if (!plugins.length) {
    return null
  }

  return (
    <NinetailedEnabledContext.Provider value={true}>
      <NinetailedProvider
        clientId={ninetailedConfig.clientId}
        environment={ninetailedConfig.environment}
        plugins={plugins}
      >
        {children}
      </NinetailedProvider>
    </NinetailedEnabledContext.Provider>
  )
}
